import './index.less';

import classNames from 'classnames';
import React, { PropsWithChildren, ReactNode, useImperativeHandle, useRef } from 'react';
import { Collapse } from 'tdesign-react';
import CollapsePanel from 'tdesign-react/es/collapse/CollapsePanel';

import { wrapAsyncFunction } from '../../../../utils';
import FormComponent from '../../form';
import type { ICustomConfig, IFormItemProps, IFormValue } from '../../interface';

export interface ICardForm {
  key: string;
  title: string;
  pageId: string;
  cardConfig?: any;
  formConfig?: any;
  fieldsConfig: any[];
  extendControlConfig?: {
    footerOpDom?: ReactNode;
    customRender?: { [key: string]: any };
    customConfig?: ICustomConfig;
    onSubmitFail?: any;
    isDraft?: boolean;
    refactorFieldsConfig?: (configs: IFormItemProps[]) => IFormItemProps[];
  };
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

interface ICardFormProps {
  cRef?: any;
  readonly?: boolean;
  formData?: IFormValue;
  className?: string;
  theme?: 'card' | 'normal';
  hasCollapse?: boolean;
  defaultExpandAll?: boolean;
  titleStyle?: string;
  onSubmit?: (params: any) => Promise<any>;
  submitCallback?: (value: any, params?: any) => any;
  loading?: boolean;
}

const CardForm: React.FC<PropsWithChildren<ICardForm & ICardFormProps>> = (props) => {
  useImperativeHandle(props.cRef, () => ({
    formRef: formRef.current,
  }));

  const formRef = useRef<any>();

  const { extendControlConfig = {} } = props;

  const onSubmit = async (values: IFormValue | false) => {
    const ret = await props.onSubmit?.(values);
    props.submitCallback?.(ret, values);
  };

  return (
    <div className="cardFormWrap">
      <div className={'cardForm'}>
        {!props.hasCollapse && <FormComponent
          cRef={formRef}
          pageId={props.pageId}
          repeatConfig={props.repeatConfig}
          fieldsConfig={props.fieldsConfig}
          formData={props.formData}
          className={props.className}
          onSubmit={wrapAsyncFunction(onSubmit)}
          formConfig={props.formConfig}
          {...extendControlConfig}
        />}
        {props.hasCollapse
          && <Collapse
            borderless
            expandIconPlacement='right'
            defaultExpandAll={props.defaultExpandAll ?? true}
          >
            <CollapsePanel
              header={props.title}
              style={{ marginBottom: 15 }}
              className={classNames(props.titleStyle)}
            >
              <FormComponent
                cRef={formRef}
                pageId={props.pageId}
                repeatConfig={props.repeatConfig}
                fieldsConfig={props.fieldsConfig}
                formData={props.formData}
                className={props.className}
                onSubmit={wrapAsyncFunction(onSubmit)}
                formConfig={props.formConfig}
                {...extendControlConfig}
              />
            </CollapsePanel>
          </Collapse>}
      </div>
      {props.children}
    </div>
  );
};

export default CardForm;
